import React from 'react';
import styled from 'styled-components';
import {Subhead} from '../../../../components/Typography';

const LocationUnavailable = styled.div`
  border-radius: 8px;
  background-color: #f7f7f7;
  padding: 5px;
  margin-top: ${props => (props.marginTop ? props.marginTop : '-16px')};
  display: grid;
  grid-gap: 12px;
  grid-template-columns: min-content auto;
  align-items: center;
  margin-bottom: 10px;
`;

const UnavailableMessage = ({title, marginTop}) => {
  return (
    <LocationUnavailable marginTop={marginTop}>
      <i className="fal fa-exclamation-circle" />
      <Subhead style={{fontWeight: '400'}}>{title}</Subhead>
    </LocationUnavailable>
  );
};

export default UnavailableMessage;
